import { BaseSelect } from '@app/components';
import { roleApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IRole } from '@tickeat/permissions';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IRole>();

export const RoleSelect = ({ label = 'Rôles', ...props }: ResourceSelectParentProps<IRole>) => {
  const columns = [
    // @ts-ignore
    columnHelper.accessor('name', {
      header: () => <BaseSelect.ListHeaderItem width="100%">Nom</BaseSelect.ListHeaderItem>,
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={roleApi.useReadManyRolesQuery}
      {...props}
    />
  );
};
